import React, { useContext, useRef } from "react";
import "../style.css";
import { Editor } from "@tinymce/tinymce-react/lib/cjs/main/ts/components/Editor";
import { StepperContext } from "../context/StepperContext";
import { motion } from "framer-motion";

export default function ArtContext() {
  const { postData, setPostData, setFinished } = useContext(StepperContext);

  const editorRef = useRef(null);

  const getText = () => {
    setPostData({ ...postData, content: editorRef.current.getContent() });
  };

  const validateCheck = (e) => {
    if (e.target.checked && postData.content.length > 1000) {
      setFinished(true);
    } else if (e.target.checked && postData.content.length < 1000) {
      e.target.checked = false;
      setFinished(false);
    }
  };

  return (
    <motion.div
      className="w-full h-[95%] pt-3"
      animate={{ opacity: 1 }}
      initial={{ opacity: 0 }}
      transition={{ ease: "easeOut", duration: 0.4, delay: 0.3 }}
    >
      {Editor && (
        <Editor
          onChange={getText}
          onInit={(evt, editor) => (editorRef.current = editor)}
          apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
          init={{
            placeholder: "Type in at least 180 words",
            plugins: "wordcount",
            resize: false,
            toolbar_mode: "sliding",
            height: 320,
            width: "100%",
            menubar: false,
            toolbar:
              "undo redo | formatselect | " +
              "fontsize bold italic forecolor backcolor | alignleft aligncenter " +
              "alignright alignjustify | outdent indent " +
              "blockquote styles",
            content_style: "body { background: #121212 }",
            content_css: "dark",
            skin: "material-outline",
            icons: "small",
          }}
        />
      )}

      <div className="mt-3 flex flex-row items-center justify-end">
        <input
          type="checkbox"
          className="checkbox checkbox-md mr-3"
          style={{ width: 0, height: 0 }}
          onChange={validateCheck}
          name="check"
          id="check"
        />
        <label
          htmlFor="check"
          className="bg-OrangyRed text-white py-1 px-2 font-medium rounded-lg transition ease-in-out hover:scale-110"
        >
          Publish
        </label>
      </div>
    </motion.div>
  );
}
